export default __webpack_public_path__ + "static/media/qr-code.cb84efe8.svg";